import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const SubmittedStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 75 18", ...rest } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            data-cy="submittedBadge"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                transform="translate(-848 -435) translate(848 435)"
            >
                <rect
                    width="74.97"
                    height="17.69"
                    x="0"
                    y="0"
                    fill="#54D1C8"
                    rx="1.966"
                ></rect>
                <path
                    fill="#210071"
                    fillRule="nonzero"
                    d="M8.289 13.052c-1.423 0-2.765-.789-3.018-2.338l1.227-.311c.126 1.054.875 1.55 1.814 1.55.95 0 1.503-.525 1.503-1.204 0-1.837-4.02-1.227-4.02-3.841 0-1.383 1.117-2.189 2.453-2.189 1.002 0 1.878.426 2.419 1.388l-1.025.634c-.317-.6-.818-.922-1.434-.922-.668 0-1.175.426-1.175 1.025 0 1.67 4.02 1.1 4.02 3.795 0 1.486-1.233 2.413-2.764 2.413zm7.152.023c-2.108 0-3.04-1.261-3.04-3.242V4.829h1.237v4.866c0 1.4.438 2.182 1.803 2.182 1.37 0 1.814-.789 1.814-2.194V4.83h1.238v4.946c0 2.033-.945 3.3-3.052 3.3zm5.125-.11V4.83h2.7c1.279 0 2.552.587 2.552 2.16 0 .77-.461 1.393-.974 1.64.795.271 1.371 1.135 1.371 2.016 0 1.491-1.204 2.32-2.632 2.32h-3.017zm1.238-4.762h1.641c.645 0 1.232-.3 1.232-1.146 0-.737-.57-1.111-1.387-1.111h-1.486v2.257zm0 3.582h1.797c.898 0 1.399-.42 1.399-1.278 0-.697-.524-1.233-1.37-1.233h-1.826v2.511zM34.277 4.83h1.676v8.137H34.76V6.539l-2.235 5.736h-1.203l-2.234-5.736v6.427h-1.192V4.829h1.675l2.356 6.058 2.35-6.058zm3.933 8.137V4.829h1.238v8.137H38.21zm5.223 0V5.94h-2.649V4.83h6.53V5.94h-2.643v7.026h-1.238zm7.17 0V5.94h-2.65V4.83h6.531V5.94h-2.643v7.026h-1.238zm5.211 0V4.829h5.384v1.14h-4.146v2.35h3.812v1.14h-3.812v2.338h4.146v1.169h-5.384zm7.227 0V4.829h2.304c2.747 0 4.21 1.485 4.21 4.129 0 2.54-1.504 4.008-4.222 4.008h-2.292zm1.238-1.14h.939c1.918 0 3.098-.813 3.098-2.92 0-2.045-.892-2.937-2.989-2.937H64.28v5.856z"
                ></path>
            </g>
        </svg>
    );
};
